export default __webpack_public_path__ + "static/media/attractions8.0786db96.png";